// Source/Product-Card-Details/Component.ts
var Marker_Product_Details = "\uD83D\uDCD2";
var Hub_Path = `/search`;
var Endpoint_Product_Details = `${Hub_Path}?q=${Marker_Product_Details}`;

class ProductCardDetails extends HTMLElement {
  controller = new AbortController;
  connectedCallback() {
    const { signal } = this.controller;
    const preload = this.preload.bind(this);
    const open = this.open.bind(this);
    const opener = this.part_opener;
    opener.addEventListener("mouseover", preload, { signal });
    opener.addEventListener("focus", preload, { signal });
    opener.addEventListener("click", open, { signal });
    const card = this.part_card;
    card?.addEventListener("hover", preload, { signal });
    this.addEventListener("click", (event) => {
      event.stopImmediatePropagation();
    }, { signal });
    const popover = this.part_popover;
    popover.addEventListener("beforetoggle", (event) => {
      const e = event;
      const state = e.newState === "open";
      document.body.dataset.productCardDetailsPopover = String(state);
    });
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  preload() {
    this.load();
  }
  open(_event) {}
  async load() {
    if (this.isLoaded)
      return;
    this.dataset.isLoaded = String(true);
    this.furnish();
  }
  async furnish() {
    const html = await this.fetch();
    const content = this.part_content;
    content.innerHTML = html;
  }
  async fetch() {
    const parameters = new Map;
    parameters.set("Variant", this.dataset.variant);
    parameters.set("Handle", this.dataset.handle);
    parameters.set("Type", this.dataset.type);
    const entries = Array.from(parameters.entries());
    const pairs = entries.map(([key, value]) => `${key}:${value}`).join(";");
    const payload = encodeURIComponent(pairs);
    const query = `${Endpoint_Product_Details}${payload}`;
    const url = new URL(query, location.href);
    return fetch(url).then((response) => response.text());
  }
  get part_card() {
    return this.closest(`.card-product , .Boost-Search-Card`);
  }
  get part_opener() {
    return this.querySelector(`:scope > button`);
  }
  get part_content() {
    return this.querySelector(`[ class *= '-Content' ]`);
  }
  get part_popover() {
    return this.querySelector(`[ class *= '-Popover' ]`);
  }
  get isLoaded() {
    return this.dataset.isLoaded === "true";
  }
}

// Source/Product-Card-Details/mod.ts
customElements.define("product-card-details", ProductCardDetails);
